import { DatePicker, Input, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormActionButton from '../../ui/FormActionButton';
import FormWrapper from './FormWrapper';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Title from '../../ui/Title';
import { fetchCountryList } from '../../../store/slices/country-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const CountryForm = () => {
    const [countryName, setCountryName] = useState('');

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: countries } = useSelector((state) => state.country);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchCountryList())
    }, []);

    useEffect(() => {
        if(MODE === 'EDIT' && countries.length) {
            const ID = searchParams.get('id');
            const selectedCountry = countries.filter((item) => item.country_id === ID);
            setCountryName(selectedCountry[0].country_name);
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, countries]);

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'country_name': countryName,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.country_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/country/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/country-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }
        
        
    }
    const resetHandler = () => {
        setCountryName('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Country</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>Country Name:</label>
                    <Input 
                        onChange={(e) => setCountryName(e.target.value)} 
                        value={countryName}
                        size='large' 
                        placeholder='Country Name' 
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default CountryForm;


